import React from 'react';

import { cx } from '@emotion/css';
import Image from 'next/image';
import styles from './ServicesView.module.scss';

export const ServicesView = () => {
  return (
    <section className={styles.qeeper_delivers}>
      <div className={cx(styles.container, styles.root)}>
        <div
          className={cx(styles.heading_wraper, styles.qeeper_heading_wraper)}>
          <h3
            className={cx(
              styles.site_title,
              styles.h3,
              styles.qeeper_site_title,
            )}>
            Qeeper delivers a comprehensive range of
            <br /> expert services, including 
          </h3>
        </div>

        <div className={styles.root}>
          <div className={styles.expert_services}>
            <ul className={styles.expert_services_ul}>
              <li className={cx(styles.cstm_li, styles.es_li)}>
                <div className={styles.service_tag}>
                  <Image
                    width={20}
                    height={28}
                    src="/images/propertyManager/services/heating-engineers.svg"
                    alt="heating engineers"
                  />
                  <span className={styles.tag_text}>Heating Engineers</span>
                </div>
              </li>
              <li className={cx(styles.cstm_li, styles.es_li)}>
                <div className={styles.service_tag}>
                  <Image
                    width={28}
                    height={28}
                    src="/images/propertyManager/services/plumbers.svg"
                    alt="plumbers"
                  />
                  <span className={styles.tag_text}>Plumbers</span>
                </div>
              </li>
              <li className={cx(styles.cstm_li, styles.es_li)}>
                <div className={styles.service_tag}>
                  <Image
                    width={28}
                    height={28}
                    src="/images/propertyManager/services/drainage-specialists.svg"
                    alt="drainage specialists"
                  />
                  <span className={styles.tag_text}>Drainage Specialists</span>
                </div>
              </li>
              <li className={cx(styles.cstm_li, styles.es_li)}>
                <div className={styles.service_tag}>
                  <Image
                    width={22}
                    height={28}
                    src="/images/propertyManager/services/electricians.svg"
                    alt="electricians"
                  />
                  <span className={styles.tag_text}>Electricians</span>
                </div>
              </li>
              <li className={cx(styles.cstm_li, styles.es_li)}>
                <div className={styles.service_tag}>
                  <Image
                    width={28}
                    height={28}
                    src="/images/propertyManager/services/locksmiths.svg"
                    alt="locksmiths"
                  />
                  <span className={styles.tag_text}>Locksmiths</span>
                </div>
              </li>
              <li className={cx(styles.cstm_li, styles.es_li)}>
                <div className={styles.service_tag}>
                  <Image
                    width={20}
                    height={28}
                    src="/images/propertyManager/services/handyman-services.svg"
                    alt="handyman"
                  />
                  <span className={styles.tag_text}>Handyman Services</span>
                </div>
              </li>

              <li className={cx(styles.cstm_li, styles.es_li)}>
                <div className={styles.service_tag}>
                  <Image
                    width={28}
                    height={28}
                    src="/images/propertyManager/services/glazing-specialists.svg"
                    alt="glazing specialists"
                  />
                  <span className={styles.tag_text}>Glazing Specialists</span>
                </div>
              </li>
              <li className={cx(styles.cstm_li, styles.es_li)}>
                <div className={styles.service_tag}>
                  <Image
                    width={29}
                    height={28}
                    src="/images/propertyManager/services/decorators.svg"
                    alt="decorators"
                  />
                  <span className={styles.tag_text}>Decorators</span>
                </div>
              </li>
              <li className={cx(styles.cstm_li, styles.es_li)}>
                <div className={styles.service_tag}>
                  <Image
                    width={29}
                    height={28}
                    src="/images/propertyManager/services/appliance-engineers.svg"
                    alt="appliance-engineers"
                  />
                  <span className={styles.tag_text}>Appliance Engineers</span>
                </div>
              </li>
            </ul>
            <div className={styles.offer_services}>
              <p className={cx(styles.off_text, styles.p)}>
                Additionally, we offer essential services such as 
                <b>Landlord Certificates and Fire Risk Assessors</b> to ensure
                your property portfolio remains compliant and secure.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
